<template>
  <div>
    <span class="urlLink"><a :href="link" style="color:black" target="_blank">{{ link }}</a>
    </span>
    <!-- this no longer works in an iframes
    <div class="ml-2 urlLink pointer" @click="copyToClipboard(link)">
<v-icon>mdi-clipboard-arrow-up-outline</v-icon>{{ $t('linkSharer.copy') }}
</div> -->
      <br><br>
    <qrcode-vue :value="link" size="300" level="H" />
  </div>
</template>

<script>

  import QrcodeVue from 'qrcode.vue'

  export default {
    name: 'LinkSharer',

    components: {
      QrcodeVue,
    },

    props: {
      link: {
        type: String,
        default: '',
      },
    },

    data () {
      return {
      }
    },

    methods: {
      copyToClipboard (value) {
        navigator.clipboard.writeText(value)
        alert(value + this.$t('linkSharer.copied-to-clipboard'))
      },
    },
  }

</script>

<style scoped>

.urlLink {
    font-size: .8em;
    font-weight: bold;
    color: black;
}

.pointer {
  cursor: pointer;
}
</style>
